'use strict';

/**
 * Initialize date input formatting and validation handlers.
 * @returns {void}
 */
module.exports = function () {
    var DATE_INPUT_SELECTOR = '.bopis-form-date-input, .ckc-pickup-appointment-date, .my-orders-datepicker, .appointment-date, .nominee-dob, .register-form-date-input, .profile-form-date-input, .giftvoucher-data-trigger, .dob-input, #profile-dob, #erp-customer-dob, #dateofbirth, .date-of-birth-field';
    var DATE_PATTERN = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    var DATE_PATTERN_STRING = '^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/[0-9]{4}$';
    var MIN_YEAR = 1900;
    var MAX_YEAR = 2099;
    var DEFAULT_ERROR_MESSAGE = 'Please enter date in DD/MM/YYYY format';

    /**
     * Validate a date string in DD/MM/YYYY format.
     * @param {string} value - Date string to validate.
     * @returns {boolean} Whether the date is valid.
     */
    function isValidDate(value) {
        if (!DATE_PATTERN.test(value)) {
            return false;
        }

        var parts = value.split('/');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10) - 1;
        var year = parseInt(parts[2], 10);
        var date = new Date(year, month, day);

        return date.getFullYear() === year
            && date.getMonth() === month
            && date.getDate() === day
            && year >= MIN_YEAR
            && year <= MAX_YEAR;
    }

    /**
     * Resolve error message for a date input.
     * @param {jQuery} $input - Date input element.
     * @returns {string} Message text.
     */
    function getErrorMessage($input) {
        return $input.data('pattern-mismatch') || DEFAULT_ERROR_MESSAGE;
    }

    /**
     * Update the feedback message associated with a date input.
     * @param {jQuery} $input - Date input element.
     * @param {string} message - Message to display.
     * @returns {void}
     */
    function updateFeedback($input, message) {
        var $feedback = $input.closest('.form-group').find('.invalid-feedback, .custom-feedback').first();
        if ($feedback.length) {
            $feedback.text(message);
        }

        $('#tryAtShowroomForm .date-picker, #bopisForm .date-picker, .dyoj-customize-form .date-picker').addClass('is-invalid');
    }

    /**
     * Validate a date input field and apply UI feedback.
     * @param {jQuery} $input - Date input element.
     * @returns {boolean} Whether the input is valid.
     */
    function validateDateInput($input) {
        var value = ($input.val() || '').trim();

        if (!value) {
            if ($input[0] && $input[0].setCustomValidity) {
                $input[0].setCustomValidity('');
            }
            $input.removeClass('is-invalid');
            return true;
        }

        if (value.length < 10) {
            if ($input[0] && $input[0].setCustomValidity) {
                $input[0].setCustomValidity('');
            }
            $input.removeClass('is-invalid');
            return true;
        }

        if (isValidDate(value)) {
            if ($input[0] && $input[0].setCustomValidity) {
                $input[0].setCustomValidity('');
            }
            $input.removeClass('is-invalid');
            return true;
        }

        var message = getErrorMessage($input);
        if ($input[0] && $input[0].setCustomValidity) {
            $input[0].setCustomValidity(message);
        }
        $input.addClass('is-invalid');
        updateFeedback($input, message);
        return false;
    }

    /**
     * Ensure validation attributes exist on a date input.
     * @param {jQuery} $input - Date input element.
     * @returns {void}
     */
    function applyDateAttributes($input) {
        if (!$input.attr('pattern')) {
            $input.attr('pattern', DATE_PATTERN_STRING);
        }
        if (!$input.data('pattern-mismatch')) {
            $input.attr('data-pattern-mismatch', DEFAULT_ERROR_MESSAGE);
        }
    }

    /**
     * Format a string into DD/MM/YYYY while typing.
     * @param {string} value - Raw input value.
     * @returns {string} Formatted value.
     */
    function formatDateInput(value) {
        var digits = value.replace(/\D/g, '').slice(0, 8);
        var day = digits.slice(0, 2);
        var month = digits.slice(2, 4);
        var year = digits.slice(4, 8);
        var formatted = day;

        if (digits.length > 2) {
            formatted += '/' + month;
        }
        if (digits.length > 4) {
            formatted += '/' + year;
        }

        return formatted;
    }

    $(DATE_INPUT_SELECTOR).each(function () {
        applyDateAttributes($(this));
    });

    $(document).on('focusin', DATE_INPUT_SELECTOR, function () {
        applyDateAttributes($(this));
    });

    $(document).on('keydown', DATE_INPUT_SELECTOR, function (event) {
        if (event.key === '/' || event.key === 'Divide') {
            event.preventDefault();
        }
    });

    $(document).on('input', DATE_INPUT_SELECTOR, function () {
        var $input = $(this);
        var formatted = formatDateInput($input.val());
        if ($input.val() !== formatted) {
            $input.val(formatted);
        }

        if (formatted.length === 10) {
            validateDateInput($input);
        }
    });

    $(document).on('blur change', DATE_INPUT_SELECTOR, function () {
        validateDateInput($(this));
    });
};
